/* TypeScript file generated from HomepassLogoFullscreen.re by genType. */
/* eslint-disable import/first */


import * as React from 'react';

// tslint:disable-next-line:no-var-requires
const HomepassLogoFullscreenBS = require('./HomepassLogoFullscreen.bs');

import {style as ReactDOMRe_style} from '../../src/shims/ReactDOMRe.shim';

// tslint:disable-next-line:interface-over-type-literal
export type Props = {
  readonly className?: string; 
  readonly style?: ReactDOMRe_style; 
  readonly testID?: string
};

export const $$default: React.ComponentType<{
  readonly className?: string; 
  readonly style?: ReactDOMRe_style; 
  readonly testID?: string
}> = HomepassLogoFullscreenBS.default;

export default $$default;
